var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EmptyStateEntry',{attrs:{"title":_vm.$t('issue-log-is-empty.title'),"text":_vm.$t('issue-log-is-empty.description'),"image-src":"/images/empty-action-log.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }